import isCompany from './isCompany'

const kind = kind => {
  if (isCompany(kind)) {
    return 'Pessoa jurídica'
  }

  return 'Pessoa física'
}

export default kind
